import { FormControl, FormGroup, Validators } from '@angular/forms';

export enum Distributor {
    MCKESSON = 'McKesson',
    MEDLINE = 'Medline',
    HENRY_SCHEIN = 'Henry Schein',
    THERMOFISHER = 'ThermoFisher',
    VWR = 'VwR',
    CARDINAL = 'Cardinal',
    AVANTOR = 'Avantor',
    FRANKLIN_YOUNG = 'FranklinYoung',
    PRECISION = 'Precision',
    NDC = 'NDC'
}

export interface OrderDetailsForm {
    productLine: string;
    isDistributor: boolean;
    distributorName: string | null;
    isCprContract: boolean;
    monthsOfInventory: number;
    additionalEmails: string[];
}

export interface OrderDetailsFormGroup {
    isDistributor: FormControl<boolean | null>;
    distributorName: FormControl<string | null>;
    isCprContract: FormControl<boolean | null>;
    monthsOfInventory: FormControl<number | null>;
    additionalEmails: FormControl<string[] | null>;
}

export const createOrderDetailsFormGroup = (): FormGroup<OrderDetailsFormGroup> => {
    return new FormGroup<OrderDetailsFormGroup>({
        isDistributor: new FormControl<boolean | null>(null),
        distributorName: new FormControl<string | null>(null),
        isCprContract: new FormControl<boolean | null>(null),
        monthsOfInventory: new FormControl<number | null>(null, [
            Validators.required,
            Validators.min(1),
            Validators.max(12)
        ]),
        additionalEmails: new FormControl<string[] | null>(null)
    });
};
